export const environment = {
  SERVER_URL: `./`,
  mockData: true, // can be true if not dependent on REST API
  development: false,
  production: false,
  hmr: false,
  useHash: true,
  baseUrl: "https://dev-kenya.cargoes.com",
  wso2amEndPoint:'',
  wso2amApiVersion: '',
  identityServerName: '/aum', 
  assetsEndPoint: '/admin-ui',
  reCaptchaKey:'6LejTLsUAAAAAG66e0GEF7ijE7zeWl4if1yi0xyG',
  recaptchaEnable : true,
  appTitle:'app.label.index.title.consumer',
  appVersion: '1.0.0',
  botEnable: false,
  languages: 'en,ar,es,fr,ru',
  tariffFinderUrl: "https://www.tariffinder.ca/3ce/en/",
  tariffUiTheme: "bdc",
  tariffCountryOfDestination: "AE",
  menuOrder: ['bireports', 'dashboard', 'business-Registration', 'licensing', 'leasing', 'bps', 'user-Mgmt', 'workforce'],
  preloadBeforeLogin:['landing', 'dashboard'],
  preloadAfterLogin:['settings', 'ics-declaration', 'ums-manifest'],
  declrationApiVersion:"v1"
};
